// extracted by mini-css-extract-plugin
export default {"root":"AIModelHistoryHeader_root__sYWR9","header-text":"AIModelHistoryHeader_header-text__tyDeD","select":"AIModelHistoryHeader_select__aTgVa"};